// Native Contact Picker (Web Contacts API). Only available on some mobile browsers (Chrome/Android, over HTTPS).
export const contactsSupported = typeof navigator !== "undefined"
  && "contacts" in navigator && "ContactsManager" in window;

// Prefer international format (starts with +), otherwise the first stored number. Format kept as stored.
export function normalizePhone(tels) {
  const arr = Array.isArray(tels) ? tels : (tels ? [tels] : []);
  const cleaned = arr.map((t) => (t == null ? "" : t.toString()).trim()).filter(Boolean);
  if (!cleaned.length) return "";
  const intl = cleaned.find((t) => t.replace(/[\s()/.-]/g, "").startsWith("+"));
  return (intl || cleaned[0]).replace(/\s+/g, " ").trim();
}

export async function pickContact() {
  if (!contactsSupported) return null;
  try {
    const results = await navigator.contacts.select(["name", "tel"], { multiple: false });
    if (!results || !results.length) return null;
    const c = results[0];
    const name = Array.isArray(c.name) ? (c.name[0] || "") : (c.name || "");
    const phone = normalizePhone(c.tel);
    return { name: name || "", phone };
  } catch {
    return null;
  }
}
